var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-switch',{attrs:{"label":`${_vm.$t('schema.builder.inputs.options.required')}`,"input-value":_vm.options.required},on:{"change":function($event){return _vm.update({required: $event})}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }